import { findTenantConfigContent } from './globalFollowSettings';

export const REGISTER_CONFIG_KEY = 'register';

export const DEFAULT_REGISTER_CONFIG = {
  emailRegister: true,
  phoneRegister: true,
  emailLogin: true,
  phoneLogin: true,
  forgotPassword: true,
  tourists: false,
  needPromotionCode: false,
  verifyCode: false,
  enNames: [],
};

function toBoolean(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'number') {
    return value === 1;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'true' || normalized === '1') {
      return true;
    }
    if (normalized === 'false' || normalized === '0') {
      return false;
    }
  }
  return Boolean(value);
}

/**
 * 從 tenant_config.register 解析登入／註冊開關。
 */
export function normalizeRegisterConfig(content) {
  const source = content && typeof content === 'object' ? content : {};
  return {
    emailRegister: toBoolean(source.emailRegister, DEFAULT_REGISTER_CONFIG.emailRegister),
    phoneRegister: toBoolean(source.phoneRegister, DEFAULT_REGISTER_CONFIG.phoneRegister),
    emailLogin: toBoolean(source.emailLogin, DEFAULT_REGISTER_CONFIG.emailLogin),
    phoneLogin: toBoolean(source.phoneLogin, DEFAULT_REGISTER_CONFIG.phoneLogin),
    forgotPassword: toBoolean(source.forgotPassword, DEFAULT_REGISTER_CONFIG.forgotPassword),
    tourists: toBoolean(source.tourists, DEFAULT_REGISTER_CONFIG.tourists),
    needPromotionCode: toBoolean(source.needPromotionCode, DEFAULT_REGISTER_CONFIG.needPromotionCode),
    verifyCode: toBoolean(source.verifyCode, DEFAULT_REGISTER_CONFIG.verifyCode),
    enNames: Array.isArray(source.enNames) ? source.enNames.filter(Boolean) : [],
  };
}

export function pickRegisterConfigFromTenantList(list) {
  return normalizeRegisterConfig(findTenantConfigContent(list, REGISTER_CONFIG_KEY));
}
